export enum UserAvailabilityStatus {
  Available = 1,
  Break = 2,
  OnLeave = 3
}
